























# import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'custom_skills'

    props:
        uid:
            type: String
        reload:
            type: Boolean
            required: false

    watch:
        reload: (new_reload, old_reload)->
            if new_reload != old_reload
                @get_user_custom_skills()

    data: ()->
        alert: false
        custom_skills: []
        evaluations: []

    methods:
        has_access_right: t.has_access_right

        delete_custom_skill: (custom_skill_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette compétence personnelle ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    m.run('delete_user_custom_skill', [custom_skill_uid])
                    .then (resp)->
                        if resp.body.data.user_custom_skill_deletion.ok
                            n.success()
                            self.get_user_custom_skills()
                            self.$emit('reload-company-custom-skills')
                        else
                            n.gql_error("custom_skills: delete_custom_skill: then", resp.body.data.user_custom_skill_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "custom_skills: delete_custom_skill()")
                .catch (cancel)->
                    return

        get_user_custom_skills: ()->
            self = @
            q.run('get_user_custom_skill_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("custom_skills: get_user_custom_skills: then", e.message)
                else
                    # console.log "GET USER CUSTOM SKILLS : ", resp.body.data.user_custom_skill_set
                    self.custom_skills = resp.body.data.user_custom_skill_set
                    if self.custom_skills.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "custom_skills: get_user_custom_skills()")
    beforeMount: ()->
        # console.log "CUSTOM SKILL mounted"
        @get_user_custom_skills()
}

